import {EndpointKind} from '../core/deployment';

export class Endpoint {
  constructor(
    private kind: EndpointKind,
    private url: string,
    private name: string,
  ) {}

  public getUrl() {
    return this.url;
  }

  public getName() {
    return this.name;
  }

  public getKind(): EndpointKind {
    return this.kind;
  }

  /**
   * True for every backend that is the Identity Director Service (cloud or self-hosted):
   * lowercase attribute names, bearer tokens, `sortAttribute`, ids in the create response.
   * The name predates the self-hosted Service; it means "not MIM".
   */
  public isCloud(): boolean {
    return this.kind !== 'mim';
  }

  /** Approval workflows exist on MIM only. */
  public supportsApprovals(): boolean {
    return this.kind === 'mim';
  }
}
